/*
    This file renders component in-place of placeholder
*/

import ReactDom from 'react-dom/client';
import QuickLinksWrapper from '../QuickLinksWrapper';
import Unauthorized from '../components/Unauthorized/Unauthorized';
import AuthError from '../components/AuthError/AuthError';

export default class RenderingPlaceholders {
  /*
    The renderQuickLinksCard method renders the quick links wrapper component.
    It accepts root element as an argument and return it after rendering quick links card
  */
  static renderQuickLinksCard(quickLinksRoot) {
    const quickLinksElement = document.getElementById('quick-links-card-container');
    if (quickLinksElement) {
      if (!quickLinksRoot) {
        quickLinksRoot = ReactDom.createRoot(quickLinksElement);
      }
      quickLinksRoot.render(<QuickLinksWrapper />);
    }
    return quickLinksRoot;
  }

  /*
    The renderDashboardPageTitle method renders the dashboard title.
    It accepts root element as an argument and return it after rendering the dashboard title.
  */
  static renderDashboardPageTitle(dashboardPageTitleRoot) {
    const dashboardPageTitle = document.getElementById('dashboard-page-title');
    if (dashboardPageTitle) {
      if (!dashboardPageTitleRoot) {
        dashboardPageTitleRoot = ReactDom.createRoot(dashboardPageTitle);
      }
      dashboardPageTitleRoot.render(<div id="dashboard-page-title">Dashboard</div>);
    }
    return dashboardPageTitleRoot;
  }

  /*
    The renderUnauthorizedScreen method renders the unauthorized screen when user does not have valid user-group access.
  */
  static renderUnauthorizedScreen(unauthorizedScreenRoot, isUserLoggedIn, isAuthorized) {
    const unauthorizedScreen = document.getElementById('unauthorized-screen');
    if (unauthorizedScreen && isUserLoggedIn && !isAuthorized) {
      if (!unauthorizedScreenRoot) {
        unauthorizedScreenRoot = ReactDom.createRoot(unauthorizedScreen);
      }
      unauthorizedScreenRoot.render(<Unauthorized />);
    }
    return unauthorizedScreenRoot;
  }

  /*
    The renderAuthenticationErrorScreen method renders the auth error screen when there is a ping error.
  */
  static renderAuthenticationErrorScreen(authenticationErrorElementRoot, isAuthenticationError) {
    const authenticationErrorElement = document.getElementById('authentication-error-screen');
    if (authenticationErrorElement && isAuthenticationError) {
      const mainContentDiv = document.getElementById('main');
      mainContentDiv.className = 'router-outlet no-nav';
      if (!authenticationErrorElementRoot) {
        authenticationErrorElementRoot = ReactDom.createRoot(authenticationErrorElement);
      }
      authenticationErrorElementRoot.render(<AuthError />);
    }
    return authenticationErrorElementRoot;
  }
}
